import { render, staticRenderFns } from "./VerticalNavMenuFolderSectionTitle.vue?vue&type=template&id=81d3ef1e&scoped=true"
import script from "./VerticalNavMenuFolderSectionTitle.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuFolderSectionTitle.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuFolderSectionTitle.vue?vue&type=style&index=0&id=81d3ef1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3ef1e",
  null
  
)

export default component.exports